import {
  EClickableTarget,
  EClickableTypes,
  EClickableVariants,
} from '@/components/atoms/at-clickable/at-clickable.types';
import { EIcons } from '@/components/atoms/at-icon/icons';
import { EBlockAlignment, EThemes } from '@/lib/contentstack-sdk/types';
import { IOrPromotionalBlockProps } from './or-promotional-block.types';
import { EMlCardsTypes } from '@/components/molecules/ml-card/ml-card.types';

export const orPromoBlockMockData: IOrPromotionalBlockProps = {
  autoplay: false,
  blockAlignment: EBlockAlignment.CENTER,
  header: 'Build your dream home for less',
  title: 'Build your dream home for less',
  description:
    'Exciting offers on tailored home investments and flexible financing options.',
  cta: {
    label: 'Explore More Offers',
    url: { title: 'Explore More Offers', href: '/test' },
    type: EClickableTypes.CTA,
    variant: 'PRIMARY' as keyof typeof EClickableVariants,
    target: EClickableTarget.BLANK,
    outline: true,
    size: 'LG' as 'LG' | 'SM',
  },
  theme: EThemes.DARK,
  promos: [
    {
      chipProps: {
        label: 'Limited Time Offer',
        icon: EIcons.PRICE,
      },
      ctaProps: {
        label: 'Claim the Offer',
        href: '/test',
        variant: EClickableVariants.PRIMARY,
        type: EClickableTypes.CTA,
        outline: true,
      },
      image: {
        alt: 'Alt text',
        src: {
          mobile: '/assets/image_card.jpg',
          tablet: '/assets/image_card.jpg',
          desktop: '/assets/image_card.jpg',
        },
      },
      title: 'Save up up to $50,000 ',
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vel nulla ut purus vestibulum.',
      variant: 'promo-compact' as EMlCardsTypes,
    },
    {
      chipProps: {
        label: 'Limited Time Offer',
        icon: EIcons.PRICE,
      },
      ctaProps: {
        label: 'Claim the Offer',
        href: '/test',
        variant: EClickableVariants.PRIMARY,
        type: EClickableTypes.CTA,
        outline: true,
      },
      image: {
        alt: 'Alt text',
        src: {
          mobile: '/assets/image_card.jpg',
          tablet: '/assets/image_card.jpg',
          desktop: '/assets/image_card.jpg',
        },
      },
      title: 'YOMO (You Only Move Once)',
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vel nulla ut purus vestibulum.',
      variant: 'promo-compact' as EMlCardsTypes,
    },
  ],
};
